import { useTranslation } from "@redotech/redo-i18n";
import { RedoCheckbox } from "@redotech/redo-web/arbiter-components/checkbox/redo-checkbox";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { Tooltip } from "@redotech/redo-web/tooltip/tooltip";
import {
  getReturnRateSourceOptionLabel,
  getReturnRateSourceOptionTooltip,
  type ReturnRateSourceOption,
} from "../rate-source-selection-utils";
import { CarrierAvatar } from "./carrier-avatar";

interface SpecificRateSourceCheckboxProps {
  onChange(selected: boolean): void;
  option: ReturnRateSourceOption;
  selected: boolean;
}

const specificRateSourceTooltipEnterDelayMs = 500;

export function SpecificRateSourceCheckbox({
  onChange,
  option,
  selected,
}: SpecificRateSourceCheckboxProps) {
  const { t } = useTranslation();
  const label = getReturnRateSourceOptionLabel(t, option);
  const checkbox = option.logoCarrier ? (
    <Flex align="center" gap="sm">
      <RedoCheckbox
        ariaLabel={label}
        setValue={(value) => {
          onChange(value === true);
        }}
        size="xs"
        value={selected}
      />
      <Flex
        align="center"
        gap="sm"
        onClick={() => {
          onChange(!selected);
        }}
      >
        <CarrierAvatar carrier={option.logoCarrier} />
        <Text fontSize="xs">{label}</Text>
      </Flex>
    </Flex>
  ) : (
    <RedoCheckbox
      label={label}
      setValue={(value) => {
        onChange(value === true);
      }}
      size="xs"
      value={selected}
    />
  );
  const tooltip = getReturnRateSourceOptionTooltip(t, option);
  if (!tooltip) {
    return checkbox;
  }
  return (
    <Tooltip
      arrow
      enterDelay={specificRateSourceTooltipEnterDelayMs}
      enterNextDelay={specificRateSourceTooltipEnterDelayMs}
      placement="top"
      title={tooltip}
    >
      <Flex w="fit-content">{checkbox}</Flex>
    </Tooltip>
  );
}
